import React, { useRef, useState } from 'react'
import emailjs from '@emailjs/browser'
import './contact.css'
import ScrollReveal from '../shared/ScrollReveal'
import Contactimg from './../../assets/form-img.png'
import { useLanguage } from '../../context/LanguageContext'

const Contact = () => {
  const { t } = useLanguage()
  const form = useRef();
  const [status, setStatus] = useState('idle') // idle | sending | success | error

  const sendEmail = (e) => {
    e.preventDefault();
    setStatus('sending');

    emailjs.sendForm('service_sslu73i', 'template_nbhui15', form.current, '-Q7llD49klfap9tVT')
      .then(() => {
        setStatus('success');
        form.current.reset();
        setTimeout(() => setStatus('idle'), 5000);
      })
      .catch(() => {
        setStatus('error');
        setTimeout(() => setStatus('idle'), 5000);
      });
  };
  return (
    <div id='Contact' className='contact__background'>
      <div className="container contact__container">
        <ScrollReveal delay={0} direction='left' className="contact__main--img">
          <img src={ Contactimg } alt="Developer" className='contact__main--png'/>
        </ScrollReveal>
        <ScrollReveal delay={150} direction='right' className="contact__menu">
          <div className='contact__entete'>
            <h2 className='contact__entete--title'>{t.contact.title}</h2>
            <p className='contact__entete--subtitle'>{t.contact.subtitle}</p>
          </div>
          <div className='contact__main--mail'>
            <form ref={form} onSubmit={sendEmail}>
              <div className='contact__field'>
                <input type="text" name="name" placeholder={t.contact.name} required disabled={status === 'sending'}/>
              </div>
              <div className='contact__field'>
                <input type="email" name="email" placeholder={t.contact.email} required disabled={status === 'sending'}/>
              </div>
              <div className='contact__field'>
                <textarea name="message" rows="6" placeholder={t.contact.message} required disabled={status === 'sending'}></textarea>
              </div>
              <button
                type="submit"
                className={`contact__main--btn${status === 'sending' ? ' contact__main--btn--loading' : ''}`}
                disabled={status === 'sending'}
              >
                {status === 'sending'
                  ? <><span className='contact__spinner' />{t.contact.sending}</>
                  : t.contact.send
                }
              </button>
            </form>
            {status === 'success' && (
              <div className='contact__toast contact__toast--success'>
                <span>&#10003;</span> {t.contact.success}
              </div>
            )}
            {status === 'error' && (
              <div className='contact__toast contact__toast--error'>
                <span>&#10007;</span> {t.contact.error}
              </div>
            )}
          </div>
        </ScrollReveal>
      </div>
    </div>
  )
}

export default Contact